import React from 'react';
import { useInView } from 'react-intersection-observer';

const About = ({ data }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  return (
    <section id="about" className="py-24 bg-[#0A0A0A]">
      <div className="container mx-auto px-6">
        <div 
          ref={ref}
          className={`max-w-6xl mx-auto transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-16 text-center">
            About <span className="text-[#0066FF]">Me</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="relative group">
              <div className="absolute inset-0 bg-[#0066FF] rounded-2xl transform rotate-6 opacity-20 group-hover:rotate-12 transition-transform duration-500"></div>
              <img 
                src={data.image} 
                alt="Profile"
                className="relative rounded-2xl w-full h-[500px] object-cover shadow-2xl transform group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* Content */}
            <div className="space-y-8">
              <p className="text-lg text-gray-300 leading-relaxed">
                {data.bio}
              </p>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 pt-8">
                {data.highlights.map((item, index) => (
                  <div 
                    key={index}
                    className="text-center p-6 bg-[#1A1A1A] rounded-xl border border-white/10 hover:border-[#0066FF]/50 transition-all duration-300 hover:transform hover:scale-105"
                  >
                    <div className="text-3xl md:text-4xl font-bold text-[#0066FF] mb-2">
                      {item.number}
                    </div>
                    <div className="text-sm text-gray-400">
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
